// Secret admin base path (not linked publicly). Access requires credentials.
export const ADMIN_BASE = "/admin-panel";
